<template>
  <div class="list row">
    <h2>LTR Registracija - Kalkulacija</h2>
    <div class="actions d-flex flex-row-reverse">
      <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
      <button type="button" class="btn btn-success bi bi-plus" @click="addData" />
    </div>
    <data-table url="registration" :columns="columns" :templates="templates" :headings="headers" :actions="actions"
      ref="datatable" @yes="deleteData" name="Registration">
    </data-table>
  </div>
</template>

<script>
import RegistrationDataService from "../../services/registration.service";
import DataTable from "../widgets/DataTable.vue";
import RegistrationForm from "./RegistrationForm.vue";

export default {
  name: "registration",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: [
        "valid_from",
        "type",
        "zapremina_ccm",
        "active",
        "edit",
      ],
      headers: {
        valid_from: "Važi od",
        type: "Tip",
        zapremina_ccm: "Zapremina",
        active: "Aktivno",
        edit: "",
      },
      templates: {
        active: function (h, row) {
          return row.active == 1 ? 'Aktivno' : 'Neaktivno';
        }
      },
      actions: {
        edit: { commp: RegistrationForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: RegistrationForm,
        params: { data: {}, title: "Dodaj novu registraciju" },
      });
    },
    deleteData(data) {
      // Delete all types for this valid_from date
      RegistrationDataService.deleteByValidFrom(data.valid_from)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message || "Registracija uspešno obrisana",
          });
          this.$store.commit("app/hideModal");
          this.refreshData();
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e.response?.data?.message || e.message || "Greška pri brisanju registracije",
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  /* max-width: 750px; */
  margin: auto;
}
</style>
